/** Just Bread — nav, scroll, cart count sync */
(function () {
  var nav = document.querySelector('.site-nav');
  var toggle = document.querySelector('.nav-toggle');
  var links = document.querySelector('.nav-links');

  if (nav) {
    window.addEventListener(
      'scroll',
      function () {
        nav.classList.toggle('is-scrolled', window.scrollY > 8);
      },
      { passive: true }
    );
  }

  function closeNav() {
    if (!links || !toggle) return;
    links.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('jb-nav-open');
  }

  function openNav() {
    if (!links || !toggle) return;
    links.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('jb-nav-open');
  }

  if (toggle && links) {
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (links.classList.contains('is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });

    links.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeNav();
    });

    document.addEventListener('click', function (event) {
      if (!links.classList.contains('is-open')) return;
      if (event.target.closest('.site-nav')) return;
      closeNav();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeNav();
    });
  }

  function updateCartLink(count) {
    var link = document.querySelector('.jb-cart-link');
    if (!link) return;
    link.textContent = count > 0 ? 'Cart (' + count + ')' : 'Cart';
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (data && typeof data.item_count === 'number') {
        updateCartLink(data.item_count);
      }
    });
  }

  /* Scroll reveal — product cards only (not whole sections; keeps headings visible) */
  if ('IntersectionObserver' in window) {
    var reveal = document.querySelectorAll('.jb-product-card--shop, .jb-product-card--editorial');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    reveal.forEach(function (el, i) {
      el.classList.add('jb-reveal');
      el.style.setProperty('--jb-reveal-index', i % 8);
      io.observe(el);
    });
  }
})();
